import CustomerAccountState from "@/models/Accounts/Shared/AccountState";

export default (val: CustomerAccountState) => {
    let returnVal = "Undefined";
    switch (val) {
        case CustomerAccountState.Active:
            returnVal = "Active"
            break;
        case CustomerAccountState.ReadOnly:
            returnVal = "Read Only"
            break;
        case CustomerAccountState.Closed:
            returnVal = "Closed"
            break;
    }
    return returnVal;
}